import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FaConfig } from '@fortawesome/angular-fontawesome';
import { AuthService } from '@s8l/client-tree-lib';
import { filter, take } from 'rxjs/operators';

import { AppInitService } from './services/app-init.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public showContent = false;

  constructor(private auth: AuthService, private faConfig: FaConfig, private appInit: AppInitService, private router: Router) {
    faConfig.defaultPrefix = 'fal';
  }

  public ngOnInit() {
    // Wait for first navigation to complete before hiding loading screen
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        // Add a tiny delay to prevent any flash
        setTimeout(() => {
          this.showContent = true;
        }, 50);
      });
  }

  public get isInitialized() {
    return this.appInit.initialized && this.showContent;
  }

  public isAuth() {
    return this.auth.isAuth;
  }
}
